@for (periodPreset of periodPresets(); track periodPreset.name) {
    <button
        (click)="setPeriod(periodPreset)"
        class="preset-button"
        [class.preset-button--active]="currentPreset()?.name === periodPreset.name"
    >
        {{ periodPreset.label }}
    </button>
}
